import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import { FUND_REPORT_TYPE } from "./fund_report_constants";

const FUND_REPORT_TIME = {
    Q1_REPORT: "-03-31",
    Q2_REPORT: "-06-30",
    SEMI_REPORT: "-06-30",
    Q3_REPORT: "-09-30",
    Q4_REPORT: "-12-31",
    ANNUAL_REPORT: "-12-31",
};

class FundReportService {
    static fundReports = null;

    static getHttpClient() {
        const host = $("meta[name=es-api-origin]").attr("content");
        return new HttpClient(host);
    }

    static getFundReport(fundCode = null, category = null) {
        if (FundReportService.fundReports != null) {
            return Promise.resolve(FundReportService.filterReports(FundReportService.fundReports, category));
        }

        const httpClient = FundReportService.getHttpClient();
        const data = {
            ...(fundCode && { fundId: fundCode }),
            t: new Date().getTime(),
        };
        const url = FUND_API_SOURCES.FUND_DOCUMENT_SOURCE;
        const options = {
            data: data,
            errorHandler: (err) => {
                throw new Error("Error fetching fund reports", err);
            },
        };

        return httpClient.get(url, options).then((temp_reports) => {
            FundReportService.fundReports = temp_reports["hits"];
            return FundReportService.filterReports(FundReportService.fundReports, category);
        });
    }

    static filterReports(reports, category) {
        if (!category) {
            return reports; // Return all reports if no category is provided
        }
        return reports.filter((item) => category.includes(item.category.toLowerCase()));
    }

    static getReportTime(fundCode = null) {
        if (!fundCode) {
            return Promise.resolve(null);
        }

        return FundReportService.getFundReport(fundCode, FUND_REPORT_TYPE.FUND_REPORT_REGULAR).then((reportList) => {
            if (reportList.length > 0) {
                const reportYear = reportList[0].report_year;
                const reportType = reportList[0].report_type;
                return String(reportYear) + FUND_REPORT_TIME[reportType];
            }
            return null;
        });
    }
}

export default FundReportService;
